export const ATENDIMENTOS = {
  "psicoterapia-online": {
    slug: "psicoterapia-online",
    eyebrow: "Atendimento • Psicoterapia",
    seoTitle: "Psicoterapia Online | Sabrina Mota — Psicóloga CRP 06/201923",
    seoDescription:
      "Psicoterapia online para adultos e adolescentes com Sabrina Mota, psicóloga CRP 06/201923. Sessões de 50 minutos por videochamada, com sigilo e acolhimento.",
    lead:
      "Um espaço de escuta e compreensão, de onde você estiver. A psicoterapia online segue os mesmos princípios éticos e o mesmo cuidado do atendimento presencial.",
    facts: {
      duracao: "50 minutos por sessão",
      frequencia: "Em geral, uma vez por semana — definido em conjunto",
      modalidade: "Online, por videochamada. Também disponível presencialmente",
    },
    paraQuem: [
      "Adultos que desejam compreender questões emocionais, comportamentais ou relacionais",
      "Adolescentes que buscam um espaço de escuta e desenvolvimento",
      "Quem prefere ser atendido de onde estiver, com flexibilidade de horários",
      "O atendimento infantil está disponível de forma pontual — converse comigo para avaliarmos juntos",
    ],
    comoFunciona: [
      "A psicoterapia é um processo profissional de compreensão. Ao longo dos encontros, olhamos juntos para aquilo que trouxe você até aqui: emoções, relações, comportamentos, história e contexto de vida.",
      "Não existe um roteiro fixo. Cada processo é construído de forma individualizada, respeitando o seu tempo e os seus objetivos, dentro das normas éticas da Psicologia.",
    ],
    comoAcontece: [
      { title: "Primeiro contato", text: "Você escolhe o atendimento aqui pelo site ou me chama no WhatsApp para alinhar o início." },
      { title: "Conversa inicial", text: "Um primeiro encontro para nos conhecermos, compreender a sua demanda e combinarmos a frequência." },
      { title: "Encontros por videochamada", text: "Sessões de 50 minutos, em um ambiente tranquilo seu — só é preciso privacidade e conexão estável." },
      { title: "Caminhada conjunta", text: "O processo avança no seu ritmo, com revisões periódicas do que faz sentido para você." },
    ],
    faq: [
      {
        q: "A psicoterapia online funciona como a presencial?",
        a: "Sim. O atendimento online é regulamentado pelos órgãos profissionais da Psicologia e segue os mesmos princípios éticos, incluindo o sigilo. O que muda é apenas o meio: o encontro acontece por videochamada.",
      },
      {
        q: "O que eu preciso para a sessão online?",
        a: "Um dispositivo com câmera e microfone, conexão estável com a internet e um ambiente reservado, onde você se sinta à vontade para conversar sem interrupções.",
      },
      {
        q: "As sessões são sigilosas?",
        a: "Sim. Tudo o que é compartilhado no processo é protegido pelo sigilo profissional, conforme o Código de Ética Profissional do Psicólogo.",
      },
      {
        q: "E se eu perceber que prefiro o presencial?",
        a: "Sem problema. A modalidade pode ser revista a qualquer momento — basta conversarmos para ajustarmos o formato que fizer mais sentido para você.",
      },
    ],
    investimentoNote:
      "O valor e as orientações de pagamento são informados pela Sabrina pelo WhatsApp, com total transparência. Escolher aqui pelo site não gera nenhuma cobrança nem compromisso.",
  },

  "avaliacao-neuropsicologica": {
    slug: "avaliacao-neuropsicologica",
    eyebrow: "Atendimento • Neuropsicologia",
    seoTitle: "Avaliação Neuropsicológica | Sabrina Mota — Neuropsicóloga CRP 06/201923",
    seoDescription:
      "Avaliação neuropsicológica para crianças, adolescentes e adultos com Sabrina Mota, CRP 06/201923. Processo estruturado com devolutiva clara e orientações.",
    lead:
      "Um processo clínico estruturado para compreender como a pessoa funciona: atenção, memória, linguagem, raciocínio, funções executivas e aspectos emocionais — com uma devolutiva clara e orientações ao final.",
    facts: {
      duracao: "Encontros de 60 a 90 minutos",
      frequencia: "Processo com etapas definidas, em geral ao longo de algumas semanas",
      modalidade: "Presencial, com etapas iniciais que podem acontecer online",
    },
    paraQuem: [
      "Adultos com dúvidas sobre atenção, memória, organização ou possibilidade de TDAH ou TEA",
      "Crianças e adolescentes com dificuldades escolares ou de aprendizagem",
      "Quem já fez uma avaliação anteriormente e busca reavaliação",
      "Famílias que desejam compreender melhor o desenvolvimento e o funcionamento de uma criança",
    ],
    comoFunciona: [
      "A avaliação neuropsicológica investiga diferentes capacidades cognitivas e aspectos emocionais e comportamentais, sempre considerando a história e o contexto de cada pessoa.",
      "O processo combina entrevistas, observação clínica e instrumentos psicológicos adequados à idade e à demanda. Ao final, você recebe uma devolutiva cuidadosa, com tempo para perguntas e orientações de próximos passos.",
    ],
    comoAcontece: [
      { title: "Entrevista inicial", text: "Conversa para compreender a demanda, a história e os objetivos da avaliação." },
      { title: "Encontros de avaliação", text: "Sessões com atividades e instrumentos escolhidos para o seu caso, em ambiente tranquilo." },
      { title: "Análise técnica", text: "Integração criteriosa de todas as informações coletadas ao longo do processo." },
      { title: "Devolutiva", text: "Encontro para apresentar os resultados com clareza, responder dúvidas e orientar caminhos." },
    ],
    faq: [
      {
        q: "Preciso de encaminhamento médico para fazer a avaliação?",
        a: "Não. Qualquer pessoa pode procurar uma avaliação neuropsicológica por iniciativa própria. Encaminhamentos de médicos, escolas ou outros profissionais são bem-vindos, mas não são obrigatórios.",
      },
      {
        q: "Quanto tempo leva o processo?",
        a: "Depende da demanda e da idade. Em geral, o processo acontece ao longo de algumas semanas, entre entrevista, encontros de avaliação, análise e devolutiva. O planejamento é apresentado logo no início.",
      },
      {
        q: "Ao final, recebo algum documento?",
        a: "Sim. Quando indicado, é elaborado um documento conforme as normas profissionais vigentes, apresentado e explicado na devolutiva.",
      },
      {
        q: "A avaliação serve para adultos também?",
        a: "Sim. Adultos procuram a avaliação com frequência para compreender questões de atenção, memória, organização e aprendizagem, ou para investigar hipóteses como TDAH e TEA.",
      },
    ],
    investimentoNote:
      "O valor do processo completo e as orientações de pagamento são informados pela Sabrina pelo WhatsApp, junto com o planejamento das etapas. Escolher aqui pelo site não gera nenhuma cobrança nem compromisso.",
  },

  "atendimento-presencial": {
    slug: "atendimento-presencial",
    eyebrow: "Atendimento • Psicoterapia presencial",
    seoTitle: "Atendimento Presencial em Taboão da Serra | Sabrina Mota — Psicóloga",
    seoDescription:
      "Psicoterapia presencial em Taboão da Serra — SP com Sabrina Mota, psicóloga CRP 06/201923. Espaço reservado no Metropolitan Office, ao lado do Shopping Taboão.",
    lead:
      "O cuidado da psicoterapia em um espaço reservado e acolhedor, em Taboão da Serra — SP, ao lado do Shopping Taboão, com fácil acesso e privacidade.",
    facts: {
      duracao: "50 minutos por sessão",
      frequencia: "Em geral, uma vez por semana — definido em conjunto",
      modalidade: "Presencial — Metropolitan Office, Estr. São Francisco, 2008, Taboão da Serra",
    },
    paraQuem: [
      "Adultos que valorizam o encontro presencial para o seu processo",
      "Adolescentes que buscam um espaço de escuta e desenvolvimento",
      "Quem mora ou trabalha na região de Taboão da Serra e proximidades",
      "O atendimento infantil está disponível de forma pontual — converse comigo para avaliarmos juntos",
    ],
    comoFunciona: [
      "Os encontros acontecem em uma sala reservada, pensada para acolher cada pessoa com privacidade e conforto. O processo é o mesmo cuidado da psicoterapia: escuta, compreensão e construção conjunta.",
      "Se em algum momento fizer sentido, é possível alternar entre encontros presenciais e online — a modalidade pode ser ajustada ao longo do caminho.",
    ],
    comoAcontece: [
      { title: "Primeiro contato", text: "Você escolhe o atendimento aqui pelo site ou me chama no WhatsApp para alinhar o início." },
      { title: "Conversa inicial", text: "Um primeiro encontro para nos conhecermos e compreendermos a sua demanda." },
      { title: "Encontros presenciais", text: "Sessões de 50 minutos no consultório, em dia e horário combinados." },
      { title: "Caminhada conjunta", text: "O processo avança no seu ritmo, com revisões periódicas do que faz sentido para você." },
    ],
    faq: [
      {
        q: "Onde acontece o atendimento presencial?",
        a: "No Metropolitan Office, Estr. São Francisco, 2008 — Vila Sonia do Taboão, Taboão da Serra — SP, ao lado do Shopping Taboão. A região tem fácil acesso e estacionamento no entorno.",
      },
      {
        q: "Posso alternar entre presencial e online?",
        a: "Sim. A modalidade pode ser ajustada conforme a sua rotina — basta conversarmos com antecedência para organizarmos.",
      },
      {
        q: "As sessões são sigilosas?",
        a: "Sim. Tudo o que é compartilhado é protegido pelo sigilo profissional, conforme o Código de Ética Profissional do Psicólogo.",
      },
      {
        q: "Qual é a frequência das sessões?",
        a: "Em geral, uma vez por semana, mas a frequência é definida em conjunto, considerando a sua demanda e a sua disponibilidade.",
      },
    ],
    investimentoNote:
      "O valor e as orientações de pagamento são informados pela Sabrina pelo WhatsApp, com total transparência. Escolher aqui pelo site não gera nenhuma cobrança nem compromisso.",
  },

  "outras-possibilidades": {
    slug: "outras-possibilidades",
    eyebrow: "Atendimento • Sob medida",
    seoTitle: "Reavaliação, orientação a pais e organização de rotina | Sabrina Mota",
    seoDescription:
      "Reavaliação neuropsicológica, orientação a pais e organização de rotina para adultos com TDAH, com Sabrina Mota — Psicóloga e Neuropsicóloga CRP 06/201923.",
    lead:
      "Nem toda demanda cabe em um nome. Reavaliações neuropsicológicas, orientação a pais e organização de rotina para adultos com TDAH também fazem parte do meu trabalho.",
    facts: {
      duracao: "50 minutos por encontro",
      frequencia: "Definida conforme a demanda",
      modalidade: "Online ou presencial — o que fizer mais sentido para você",
    },
    paraQuem: [
      "Pais e mães que buscam orientação para compreender e apoiar seus filhos",
      "Adultos com TDAH que desejam organizar rotina, prazos e prioridades",
      "Quem já fez uma avaliação neuropsicológica e busca reavaliação",
      "Quem tem uma demanda diferente e quer conversar antes de decidir",
    ],
    comoFunciona: [
      "Algumas necessidades não se encaixam em um formato pronto. Nesses casos, o primeiro passo é uma conversa: compreendo o que você está buscando e, juntos, definimos o formato que faz mais sentido.",
      "Se a sua demanda não for da minha área de atuação, oriento você com honestidade sobre os caminhos possíveis.",
    ],
    comoAcontece: [
      { title: "Conversa inicial", text: "Você me conta o que está buscando — aqui pelo site ou pelo WhatsApp." },
      { title: "Compreensão da demanda", text: "Avaliamos juntos qual formato de trabalho atende melhor a sua necessidade." },
      { title: "Formato sob medida", text: "Definimos encontros, frequência e objetivos de forma individualizada." },
    ],
    faq: [
      {
        q: "Como funciona a orientação a pais?",
        a: "São encontros com os pais ou responsáveis para compreender o momento da criança ou do adolescente e construir, juntos, formas de apoiar o desenvolvimento no dia a dia.",
      },
      {
        q: "O que é a organização de rotina para adultos com TDAH?",
        a: "É um acompanhamento focado em estratégias práticas: organização de tempo, prioridades, prazos e hábitos, considerando o funcionamento de cada pessoa.",
      },
      {
        q: "Quando uma reavaliação é indicada?",
        a: "Quando já existe uma avaliação anterior e houve mudanças, evolução ou necessidade de atualização — por exemplo, para acompanhar o desenvolvimento ou rever orientações.",
      },
      {
        q: "Minha demanda é diferente de tudo isso. Posso conversar mesmo assim?",
        a: "Pode. O primeiro contato existe justamente para isso: compreender o que você procura e indicar o melhor caminho — comigo ou com outro profissional.",
      },
    ],
    investimentoNote:
      "O valor e as orientações de pagamento são informados pela Sabrina pelo WhatsApp, de acordo com o formato definido para a sua demanda. Escolher aqui pelo site não gera nenhuma cobrança nem compromisso.",
  },
};
